class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.js-section-header');
    if (!this.header) return;
    this.headerMenu = this.header.querySelectorAll('header-menu');
    this.currentScrollTop = 0;

    this.measure();
    this.boundMeasure = this.measure.bind(this);
    this.mediaQueryList = window.matchMedia('(max-width: 990px)');
    this.mediaQueryList.addEventListener('change', this.boundMeasure);

    this.boundOnScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.boundOnScroll, { passive: true });

    window.addEventListener('load', this.boundMeasure);

    // Observe header resizes (if promo bar changes height)
    this.resizeObserver = new ResizeObserver(this.boundMeasure);
    this.resizeObserver.observe(this.header);
  }

  disconnectedCallback() {
    if (!this.header) return;
    this.mediaQueryList.removeEventListener('change', this.boundMeasure);
    window.removeEventListener('load', this.boundMeasure);
    window.removeEventListener('scroll', this.boundOnScroll, { passive: true });
    this.resizeObserver?.disconnect();
  }

  measure() {
    if (this.header.classList.contains('shopify-section-header-sticky')) return;
    this.setHeaderHeight();
    this.updateHeaderBounds();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.getBoundingClientRect().height}px`);
    document.documentElement.style.setProperty('--sticky-header-height', `${this.getBoundingClientRect().height}px`);
  }

  updateHeaderBounds() {
    const rect = this.header.getBoundingClientRect();
    this.headerBounds = {
      top: rect.top + window.scrollY,
      bottom: rect.bottom + window.scrollY,
    };
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isSticky = this.header.classList.contains('shopify-section-header-sticky');
    if (scrollTop < this.currentScrollTop) {
      // SCROLLING UP (Reset/Reveal Logic)
      if (scrollTop <= this.headerBounds.top && isSticky) {
        requestAnimationFrame(this.reset.bind(this));
      } else {
        const isHidden = this.header.classList.contains('shopify-section-header-hidden');
        isHidden && requestAnimationFrame(this.reveal.bind(this));
      }
    } else if (scrollTop > this.currentScrollTop) {
      // SCROLLING DOWN (Hide Logic)
      if (scrollTop > this.headerBounds.bottom) {
        const isHidden = this.header.classList.contains('shopify-section-header-hidden');
        if (!isHidden) {
          const containsOpenMenu = Array.from(this.headerMenu || []).some((headerMenu) =>
            headerMenu.details?.hasAttribute('open'),
          );
          !containsOpenMenu && requestAnimationFrame(this.hide.bind(this));
        }
      }
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    // Back in the flow:
    this.measure();
  }
}

customElements.define('sticky-header', StickyHeader);
